export enum RingingStrategy {
  ROUND_ROBIN = "round-robin",
  RING_TEAM = "ring-team",
}

export enum VoiceProvider {
  TELNYX = "telnyx",
  AIRCALL = "aircall",
}

interface DayAvailability {
  enabled?: boolean | null;
  start?: string | null;
  end?: string | null;
}

export enum SupportVoiceCustomAudioType {
  TTS = "tts",
  URL = "url",
}

export const isE164PhoneNumber = (value: string): boolean =>
  /^\+\d{6,15}$/.test(value);

/**
 * Keep in sync with the generated `SupportSettingsRaw` voice
 * (`redo/backend/db/schema/src/types/team/SupportSettings.schema`).
 */
export interface SupportVoiceCustomAudio {
  enabled: boolean;
  type: SupportVoiceCustomAudioType;
  ttsMessage: string;
  audioUrl: string;
  audioName: string;
}

/**
 * Keep in sync with the generated `SupportSettingsRaw` voice
 * (`redo/backend/db/schema/src/types/team/SupportSettings.schema`).
 */
export interface TeamVoiceConfiguration {
  enabled: boolean;
  testPhoneNumbers: readonly string[];
  provider?: VoiceProvider;
  ringingStrategy: RingingStrategy;
  sipConnectionId?: string | null;
  sipConnectionCredential?: string | null;
  outboundVoiceProfileId?: string | null;
  voiceApplicationId?: string | null;
  billingGroupId?: string | null;
  playAutomatedMessageWhenAllAgentsAreOffline: boolean;
  sendToVoicemailWhenAllAgentsAreOffline: boolean;
  allowHoldingCallsInQueue: boolean;
  availableHoursEnabled?: boolean | null;
  availableHoursTimezone?: string | null;
  availableHours?: {
    sunday?: DayAvailability | null;
    monday?: DayAvailability | null;
    tuesday?: DayAvailability | null;
    wednesday?: DayAvailability | null;
    thursday?: DayAvailability | null;
    friday?: DayAvailability | null;
    saturday?: DayAvailability | null;
  } | null;
  inboundGreetingMessage: SupportVoiceCustomAudio;
  outboundGreetingMessage: SupportVoiceCustomAudio;
  offHoursMessage: SupportVoiceCustomAudio;
  voicemailMessage: SupportVoiceCustomAudio;
  holdMusicUrl: string;
  holdMusicName: string;
}
